export default {"src":"/_next/static/image/src/components/TooltipIcon/Info-Icon.0f885e7abd20e7c2f3fb90140e241f94.svg","height":24,"width":24};